import { render, staticRenderFns } from "./TabData.vue?vue&type=template&id=c233b76c&scoped=true&"
import script from "./TabData.vue?vue&type=script&lang=coffee&"
export * from "./TabData.vue?vue&type=script&lang=coffee&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c233b76c",
  null
  
)

export default component.exports